import React, { createContext, useContext, useMemo } from "react";
import { usePuvioIdentity } from "./identity/usePuvioIdentity";
import { usePermissions } from "./permissions/usePermissions";
import { useAnalytics } from "./analytics/useAnalytics";

/** GenesisProvider — mounts identity + permissions + analytics so the rest of the app
 *  can read them via useGenesis() without re-fetching.
 *  Already-existing app contexts (cycle, profile, etc.) are unaffected. */
const GenesisContext = createContext(null);

export function GenesisProvider({ children, autoLoadIdentity = false, autoLoadPermissions = false }) {
  const identity = usePuvioIdentity({ autoLoad: autoLoadIdentity });
  const permissions = usePermissions({ autoLoad: autoLoadPermissions });
  const analytics = useAnalytics();

  const value = useMemo(() => ({ identity, permissions, analytics }), [identity, permissions, analytics]);
  return <GenesisContext.Provider value={value}>{children}</GenesisContext.Provider>;
}

export function useGenesis() {
  const ctx = useContext(GenesisContext);
  if (!ctx) throw new Error("useGenesis must be used inside <GenesisProvider>");
  return ctx;
}
